import styled from 'styled-components';
const FullPageContainer = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    `;
export default FullPageContainer;